import RegisterForm, { OptionalRegisterFormFieldElements } from "components/authentication/RegisterForm";
import MainLayout from 'components/layout/MainLayout';
import PageTitle from 'components/PageTitle';
import { useUIStore } from 'hooks/stores/useUIStore';
import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from "mobx-react-lite";
import { NextSeo } from 'next-seo';
import Link from 'next/link';
import Router, { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { getCta } from 'utils/common';
import { isSafeRedirect } from "utils/url/isSafeRedirect";

const Register = observer(() => {
  const [guestEmailAddress, setGuestEmailAddress] = useState<string | null | false>();

  const { navigateToAccount } = useUIStore()
  const router = useRouter();
  const { currentUser } = useUserStore();
  const isRedirecting = useRef<boolean>(false);

  const redirectUrl =
    typeof router.query.redirect == 'string'
      ? router.query.redirect
      : router.query.redirect?.[0];

  useEffect(() => {
    if (currentUser && !isRedirecting.current) {
      isRedirecting.current = true;
      if (redirectUrl && isSafeRedirect(redirectUrl)) {
        router.replace(redirectUrl);
      } else {
        navigateToAccount()
      }
    }
  }, [redirectUrl, currentUser]);

  useEffect(() => {
    setGuestEmailAddress(
      typeof localStorage !== 'undefined' &&
        localStorage.getItem('guest_email_address')
    );
  }, []);

  return (
    <MainLayout additionalClassName="register">
      <NextSeo
        title="Sign Up | Win Epic Prizes | DAYMADE"
        description="Sign up for a DAYMADE account here and starting winning epic prizes"
        openGraph={{
          title: 'Sign Up | Win Epic Prizes | DAYMADE',
          description:
            'Sign up for a DAYMADE account here and starting winning epic prizes',
        }}
      />

      <PageTitle>Welcome</PageTitle>

      <div className="registerContent fullWidth flexCentered">
        {!guestEmailAddress && (
          <>
            <p style={{ margin: '1em 0 0' }}>Already have an account?</p>

            <Link
              href={redirectUrl ? `/login?redirect=${redirectUrl}` : '/login'}
            >
              <a style={{ textDecoration: 'underline' }}>Login</a>
            </Link>
          </>
        )}

        <div className="paddedMaxWidthContainer">
          <RegisterForm
            submitButtonTitle={
              redirectUrl === 'checkout' ? 'Continue to payment' : undefined
            }
            excludeFormFieldsList={[
              OptionalRegisterFormFieldElements.PHONE_NUMBER,
              OptionalRegisterFormFieldElements.DATE_OF_BIRTH,
            ]}
            completionHandler={async (token: string) => {
              if (!isRedirecting.current) {
                isRedirecting.current = true;
                Router.replace(redirectUrl ? `/${redirectUrl}` : getCta()!.url);
              }
            }}
            appleRedirectPath={router.pathname}
          />
        </div>
      </div>

      <style jsx>
        {`
          .registerContent {
            padding: 4em 0 3em;
          }

          :global(.register .subheading) {
            margin-bottom: 0.5em;
          }
        `}
      </style>
    </MainLayout>
  );
});

export default Register;
